import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {MatSidenavModule, MatButtonModule, MatListModule, MatPaginatorModule} from '@angular/material';
import {UIRouterModule} from "@uirouter/angular";
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {HttpClient} from "@angular/common/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";

import {kanServiceModule} from "../modules/services/module";

import {kanAdminModule} from '../modules/admin/module';
import {kanMainModule} from "../modules/main/module";

import {AppComponent} from './app.component';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        MatSidenavModule,
        MatButtonModule,
        MatListModule,
        MatPaginatorModule,
        UIRouterModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (HttpLoaderFactory),
                deps: [HttpClient]
            }
        }),
        kanServiceModule,
        kanMainModule,
        kanAdminModule
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts